import axios from "axios";
import { API_BASE_URL } from "./config";

const getPortalHostHeader = () => {
  if (typeof window === "undefined" || !window.location?.hostname) {
    return undefined;
  }
  return window.location.hostname.toLowerCase();
};

const getPortalHostParams = () => {
  const portalHost = getPortalHostHeader();
  return portalHost ? { portalHost } : {};
};

class DocumentationService {
  constructor() {
    this.axiosInstance = axios.create({
      baseURL: API_BASE_URL,
      withCredentials: true,
    });
  }

  async getProducts() {
    const response = await this.axiosInstance.get("/api/documentation/products", {
      params: getPortalHostParams(),
    });
    return response.data;
  }

  async getTree(productSlug) {
    const response = await this.axiosInstance.get(`/api/documentation/tree/${productSlug}`, {
      params: getPortalHostParams(),
    });
    return response.data;
  }

  async getPageByPath(productSlug, path = "") {
    const response = await this.axiosInstance.get(`/api/documentation/page/${productSlug}/by-path`, {
      params: { path, ...getPortalHostParams() },
    });
    return response.data;
  }

  async createPage(payload) {
    const response = await this.axiosInstance.post("/api/documentation/pages", payload);
    return response.data;
  }

  async updatePage(pageId, payload) {
    const response = await this.axiosInstance.put(`/api/documentation/pages/${pageId}`, payload);
    return response.data;
  }

  async deletePage(pageId, includeChildren = true) {
    const response = await this.axiosInstance.delete(`/api/documentation/pages/${pageId}`, {
      params: { includeChildren },
    });
    return response.data;
  }

  async uploadImage(file, productSlug) {
    const formData = new FormData();
    formData.append("image", file);
    formData.append("productSlug", productSlug);
    const portalHost = getPortalHostHeader();
    if (portalHost) {
      formData.append("portalHost", portalHost);
    }

    const response = await this.axiosInstance.post("/api/documentation/assets/image", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }
}

export const documentationService = new DocumentationService();
